// extracted by mini-css-extract-plugin
module.exports = {"errorScreen":"ErrorBoundary_errorScreen__2smPk","errorCard":"ErrorBoundary_errorCard__3T5dK"};